export default __webpack_public_path__ + "static/media/register.7a6a64d6.png";